import { useEffect, useState } from "react";
import { ArrowRight, Check, Circle } from "lucide-react";
import { api } from "@/lib/api";

const Dot = ({ state, n }) => (
  <span className={`h-7 w-7 shrink-0 rounded-full flex items-center justify-center text-xs font-semibold ${state === "done" ? "bg-[#198754] text-white" : state === "current" ? "bg-black text-white" : state === "late" ? "bg-[#FFC107]/30 text-[#8a6500]" : "bg-[#F1EDE6] text-[#757575]"}`}>
    {state === "done" ? <Check className="h-4 w-4" /> : n}
  </span>
);

const Steps = ({ stages, sel, setSel }) => (
  <div className="flex gap-1 overflow-x-auto no-scrollbar pb-1" data-testid="percorso-steps">
    {stages.map((s, i) => (
      <button key={s.key} onClick={() => setSel?.(i)} className={`flex items-center gap-2 pr-3 pl-1 py-1 rounded-full shrink-0 transition-colors ${sel === i ? "bg-[#E6DDCE]" : "hover:bg-[#F7F7F7]"}`} data-testid={`percorso-step-${s.key}`}>
        <Dot state={s.state} n={i + 1} />
        <span className={`text-xs ${s.state === "todo" ? "text-[#757575]" : "font-medium"}`}>{s.label}</span>
      </button>
    ))}
  </div>
);

export const Percorso = ({ oid, onTab, refresh }) => {
  const [p, setP] = useState(null);
  const [sel, setSel] = useState(null);
  useEffect(() => { api.get(`/orders/${oid}/percorso`).then((r) => { setP(r.data); setSel((s) => s ?? r.data.current); }).catch(() => {}); }, [oid, refresh]);
  if (!p) return null;
  const st = p.stages[sel ?? p.current];
  return (
    <div className="rp-card p-5 space-y-4" data-testid="percorso-card">
      <div className="flex flex-wrap items-center gap-3">
        <p className="rp-label">Percorso del cantiere · tappa {p.current + 1} di {p.stages.length}</p>
        {p.next && (
          <button onClick={() => onTab(p.next.tab)} className="ml-auto inline-flex items-center gap-2 h-9 px-4 rounded-full bg-black text-white text-sm font-medium hover:bg-[#333] transition-colors" data-testid="percorso-next-btn">
            Prossimo passo: {p.next.action} <ArrowRight className="h-4 w-4" />
          </button>
        )}
      </div>
      <Steps stages={p.stages} sel={sel} setSel={setSel} />
      <div className="grid sm:grid-cols-2 gap-2" data-testid={`percorso-items-${st.key}`}>
        {st.items.map((x) => (
          <button key={x.label} onClick={() => onTab(x.tab)} className="flex items-center gap-3 text-left rounded-2xl border border-[#EBEBEB] px-3 py-2 hover:border-black transition-colors" data-testid={`percorso-item-${st.key}-${x.tab}`}>
            {x.done ? <Check className="h-4 w-4 text-[#198754] shrink-0" /> : <Circle className="h-4 w-4 text-[#C8BDAB] shrink-0" />}
            <span className={`text-sm flex-1 ${x.done ? "text-[#757575] line-through" : ""}`}>{x.label}</span>
            {!x.done && <span className="text-xs underline shrink-0">{x.action}</span>}
          </button>
        ))}
      </div>
    </div>
  );
};

export const ClientPercorso = ({ oid }) => {
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/client/orders/${oid}/percorso`).then((r) => setP(r.data)).catch(() => {}); }, [oid]);
  if (!p) return null;
  return (
    <div className="rp-card p-5" data-testid="client-percorso">
      <p className="rp-label mb-3">Il percorso del tuo cantiere · siamo alla tappa «{p.stages[p.current].label}»</p>
      <Steps stages={p.stages} sel={p.current} />
    </div>
  );
};
